import { Stack, Typography, Box } from "@mui/material";
import { formatearNumeroConComas } from "views/Components/Shared/utils/formatNumbers";
import { styled } from "@mui/material/styles";
import { LinearProgress, linearProgressClasses } from "@mui/material";

const BorderLinearProgress = styled(LinearProgress)(({ value }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: value > 50 ? "#939393" : "#0000001F",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 7,
    backgroundColor: value > 50 ? "#EF6C00" : "#002878",
  },
}));

export default function Stat({
  stat,
  projected,
  currency,
  target,
  change,
  budget,
}) {
  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      spacing={1}
      sx={{ height: "100%", width: "100%" }}
    >
      <Stack spacing={4} direction="row">
        <Stack spacing={1} direction="row">
          {target && (
            <Typography
              sx={{
                color: "#424242",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                letterSpacing: "0.15px",
              }}
            >
              Target: {target}x
            </Typography>
          )}
          <Typography
            sx={{
              color: "#464646",
              fontFamily: "Roboto",
              fontStyle: "normal",
              fontWeight: "600",
              fontSize: target ? "24px" : budget ? "16px" : "36px",
              lineHeight: "24px",
              letterSpacing: "0.15px",
            }}
          >
            {currency === "USD" || currency === "ARS" ? "$" : ""}{" "}
            {projected ? stat : formatearNumeroConComas(stat)}
            {currency === "percentage" ? "%" : ""}
            {currency === "target" ? "x" : ""}
          </Typography>
          {budget && (
            <Typography
              sx={{
                color: "#00000099",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                letterSpacing: "0.15px",
              }}
            >
              / ${budget}
            </Typography>
          )}
          {projected && (
            <Typography
              sx={{
                color: "#424242",
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "16px",
                letterSpacing: "0.15px",
              }}
            >
              vs.
              <br />
              Proyectado
            </Typography>
          )}
        </Stack>
        {budget && (
          <Typography
            sx={{
              color: change > 50 ? "#EF6C00" : "#002878",
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "24px",
              letterSpacing: "0.15px",
            }}
          >
            {change}%
          </Typography>
        )}
      </Stack>
      {target && change != null && (
        <Typography
          sx={{
            color: change > 0 ? "#2E7D32" : "#C62828",
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "24px",
            letterSpacing: "0.15px",
          }}
        >
          {change > 0 ? "+" : "-"} {formatearNumeroConComas(change)}%
        </Typography>
      )}
      {budget && (
        <Stack sx={{ width: "100%" }}>
          <BorderLinearProgress variant="determinate" value={change} />
        </Stack>
      )}
    </Stack>
  );
}
